const states = {
  ALABAMA: 'AL',
  ALASKA: 'AK',
  AMERICAN_SAMOA: 'AS',
  ARIZONA: 'AZ',
  ARKANSAS: 'AR',
  CALIFORNIA: 'CA',
  COLORADO: 'CO',
  CONNECTICUT: 'CT',
  DELAWARE: 'DE',
  DISTRICT_OF_COLUMBIA: 'DC',
  FLORIDA: 'FL',
  GEORGIA: 'GA',
  GUAM: 'GU',
  HAWAII: 'HI',
  IDAHO: 'ID',
  ILLINOIS: 'IL',
  INDIANA: 'IN',
  IOWA: 'IA',
  KANSAS: 'KS',
  KENTUCKY: 'KY',
  LOUISIANA: 'LA',
  MAINE: 'ME',
  MARYLAND: 'MD',
  MASSACHUSETTS: 'MA',
  MICHIGAN: 'MI',
  MINNESOTA: 'MN',
  MISSISSIPPI: 'MS',
  MISSOURI: 'MO',
  MONTANA: 'MT',
  NEBRASKA: 'NE',
  NEVADA: 'NV',
  NEW_HAMPSHIRE: 'NH',
  NEW_JERSEY: 'NJ',
  NEW_MEXICO: 'NM',
  NEW_YORK: 'NY',
  NORTH_CAROLINA: 'NC',
  NORTH_DAKOTA: 'ND',
  OHIO: 'OH',
  OKLAHOMA: 'OK',
  OREGON: 'OR',
  PENNSYLVANIA: 'PA',
  RHODE_ISLAND: 'RI',
  SOUTH_CAROLINA: 'SC',
  SOUTH_DAKOTA: 'SD',
  TENNESSEE: 'TN',
  TEXAS: 'TX',
  UTAH: 'UT',
  VERMONT: 'VT',
  VIRGINIA: 'VA',
  WASHINGTON: 'WA',
  WEST_VIRGINIA: 'WV',
  WISCONSIN: 'WI',
  WYOMING: 'WY',
};

const statesArray = Object.values(states).map((value) => value);

// Keep in sync with API - constants/states.ts
const STATES_WITH_NO_DOC_FEE = [
  states.ALASKA,
  states.ALABAMA,
  states.ARKANSAS,
  states.ARIZONA,
  states.CALIFORNIA,
  states.COLORADO,
  states.CONNECTICUT,
  states.DISTRICT_OF_COLUMBIA,
  states.DELAWARE,
  states.FLORIDA,
  states.GEORGIA,
  states.HAWAII,
  states.IDAHO,
  states.ILLINOIS,
  states.INDIANA,
  states.IOWA,
  states.KANSAS,
  states.KENTUCKY,
  states.LOUISIANA,
  states.MAINE,
  states.MASSACHUSETTS,
  states.MARYLAND,
  states.MICHIGAN,
  states.MINNESOTA,
  states.MISSISSIPPI,
  states.MISSOURI,
  states.MONTANA,
  states.NEBRASKA,
  states.NEVADA,
  states.NEW_HAMPSHIRE,
  states.NEW_JERSEY,
  states.NEW_MEXICO,
  states.NEW_YORK,
  states.NORTH_CAROLINA,
  states.NORTH_DAKOTA,
  states.OHIO,
  states.OKLAHOMA,
  states.OREGON,
  states.PENNSYLVANIA,
  states.RHODE_ISLAND,
  states.SOUTH_CAROLINA,
  states.SOUTH_DAKOTA,
  states.TENNESSEE,
  states.TEXAS,
  states.UTAH,
  states.VIRGINIA,
  states.VERMONT,
  states.WASHINGTON,
  states.WEST_VIRGINIA,
  states.WISCONSIN,
  states.WYOMING,
] as const;

const statesAbbreviationMap = new Map(statesArray.map((value) => [value, value]));

const isValidStateAbbreviation = (state?: string): boolean =>
  state ? statesAbbreviationMap.has(state) : false;

export { states, statesArray, isValidStateAbbreviation, STATES_WITH_NO_DOC_FEE };
